import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import HeaderMaster from '../components/HeaderMaster';
import SideBarMaster from '../components/SideBarMaster';
import FooterNavigationMaster from '../components/FooterNavigationMaster';
import styles from './GerenciarEstabelecimento.module.css';
import { MdArrowBack, MdRefresh, MdContentCopy } from 'react-icons/md';
import { EstabelecimentosContext } from '../../../shared/contexts/EstabelecimentosContext';
import { fetchWithAuth } from '../../../shared/utils/auth';
import PainelImpressao from '../../../shared/components/PainelImpressao';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

// Hub de gerenciamento de UMA loja pelo master — reúne as ações que hoje só
// o admin dono da loja consegue fazer (Configurações/WhatsApp, Mesas, Taxas
// de Entrega, Impressão automática) e linka para Itens/Equipe (que já existem como telas globais
// do master, aqui só pré-selecionando esta loja via query string).
function GerenciarEstabelecimento() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { estabelecimentos, fetchEstabelecimentos } = useContext(EstabelecimentosContext);
  const [aba, setAba] = useState('configuracoes');

  useEffect(() => {
    fetchEstabelecimentos();
  }, []);

  const estabelecimento = estabelecimentos.find((e) => String(e.id_estabelecimento) === String(id));

  return (
    <div className={styles.secaoPrincipal}>
      <SideBarMaster />
      <div className={styles.containerDashboard}>
        <HeaderMaster />

        <div className={styles.contentDashboard}>
          <button className={styles.linkVoltar} onClick={() => navigate('/speedhub/estabelecimentos')}>
            <MdArrowBack style={{ verticalAlign: 'middle' }} /> Voltar para Estabelecimentos
          </button>

          <div className={styles.tituloSecao}>
            <div>
              <h2>{estabelecimento?.nomeEstabelecimento || `Estabelecimento #${id}`}</h2>
            </div>
          </div>

          <div className={styles.tabs}>
            {[
              { key: 'configuracoes', label: 'Configurações' },
              { key: 'mesas', label: 'Mesas' },
              { key: 'taxas', label: 'Taxas de Entrega' },
              { key: 'impressao', label: 'Impressão' },
            ].map((t) => (
              <button
                key={t.key}
                className={`${styles.tabBtn} ${aba === t.key ? styles.tabAtiva : ''}`}
                onClick={() => setAba(t.key)}
              >
                {t.label}
              </button>
            ))}
            <Link className={styles.tabBtn} to={`/speedhub/itens?estabelecimento_id=${id}`}>
              Produtos ↗
            </Link>
            <Link className={styles.tabBtn} to={`/speedhub/equipe?estabelecimento_id=${id}`}>
              Equipe ↗
            </Link>
          </div>

          {!estabelecimento ? (
            <p className={styles.estadoVazio}>Carregando dados do estabelecimento...</p>
          ) : (
            <>
              {aba === 'configuracoes' && <AbaConfiguracoes estabelecimento={estabelecimento} onAtualizado={fetchEstabelecimentos} />}
              {aba === 'mesas' && <AbaMesas idEstabelecimento={id} />}
              {aba === 'taxas' && <AbaTaxasEntrega idEstabelecimento={id} />}
              {aba === 'impressao' && <PainelImpressao idEstabelecimento={id} embutido />}
            </>
          )}
        </div>
      </div>
      <FooterNavigationMaster />
    </div>
  );
}

// ===================== Aba: Configurações + WhatsApp ===================== //
function AbaConfiguracoes({ estabelecimento, onAtualizado }) {
  const [nomeEstabelecimento, setNomeEstabelecimento] = useState(estabelecimento.nomeEstabelecimento || '');
  const [endereco, setEndereco] = useState(estabelecimento.endereco || '');
  const [telefone, setTelefone] = useState(estabelecimento.telefone || '');
  const [email, setEmail] = useState(estabelecimento.email || '');
  const [horaAbertura, setHoraAbertura] = useState(estabelecimento.hora_abertura || '');
  const [horaFechamento, setHoraFechamento] = useState(estabelecimento.hora_fechamento || '');
  const [salvandoDados, setSalvandoDados] = useState(false);
  const [salvandoHorario, setSalvandoHorario] = useState(false);
  const [alterandoStatus, setAlterandoStatus] = useState(false);
  const [regenerandoPin, setRegenerandoPin] = useState(false);
  const [pinCozinha, setPinCozinha] = useState(estabelecimento.pin_cozinha || '');

  const [whatsappPhoneId, setWhatsappPhoneId] = useState('');
  const [whatsappToken, setWhatsappToken] = useState('');
  const [whatsappDisplay, setWhatsappDisplay] = useState(estabelecimento.whatsapp_display_phone_number || '');
  const [salvandoWhatsapp, setSalvandoWhatsapp] = useState(false);

  const id = estabelecimento.id_estabelecimento;

  const salvarDados = async (e) => {
    e.preventDefault();
    setSalvandoDados(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/atualizar-estabelecimento`, {
        method: 'POST',
        body: JSON.stringify({ id, nomeEstabelecimento, endereco, telefone, email })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.message || 'Erro ao salvar dados.');
      alert('Dados atualizados com sucesso!');
      onAtualizado();
    } catch (err) {
      alert(err.message);
    } finally {
      setSalvandoDados(false);
    }
  };

  const alternarStatus = async () => {
    const novoStatus = estabelecimento.status_aberto === 'aberto' ? 'fechado' : 'aberto';
    setAlterandoStatus(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/estabelecimentos/${id}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status_aberto: novoStatus })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao alterar status.');
      onAtualizado();
    } catch (err) {
      alert(err.message);
    } finally {
      setAlterandoStatus(false);
    }
  };

  const salvarHorario = async (e) => {
    e.preventDefault();
    setSalvandoHorario(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/estabelecimentos/${id}/horario`, {
        method: 'PUT',
        body: JSON.stringify({ hora_abertura: horaAbertura, hora_fechamento: horaFechamento })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao salvar horário.');
      alert('Horário atualizado!');
      onAtualizado();
    } catch (err) {
      alert(err.message);
    } finally {
      setSalvandoHorario(false);
    }
  };

  const regenerarPin = async () => {
    if (!window.confirm('Gerar um novo PIN? O PIN atual da Tela da Cozinha deixará de funcionar.')) return;
    setRegenerandoPin(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/estabelecimentos/${id}/pin-cozinha/regenerar`, { method: 'POST' });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao gerar novo PIN.');
      setPinCozinha(data.pin_cozinha);
    } catch (err) {
      alert(err.message);
    } finally {
      setRegenerandoPin(false);
    }
  };

  const conectarWhatsapp = async (e) => {
    e.preventDefault();
    if (!whatsappPhoneId.trim() || !whatsappToken.trim()) {
      alert('Informe o Phone Number ID e o Access Token.');
      return;
    }
    setSalvandoWhatsapp(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/estabelecimentos/${id}/whatsapp`, {
        method: 'PUT',
        body: JSON.stringify({
          whatsapp_phone_number_id: whatsappPhoneId.trim(),
          whatsapp_access_token: whatsappToken.trim(),
          whatsapp_display_phone_number: whatsappDisplay.trim() || null
        })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao conectar WhatsApp.');
      alert('WhatsApp conectado com sucesso!');
      setWhatsappToken('');
      onAtualizado();
    } catch (err) {
      alert(err.message);
    } finally {
      setSalvandoWhatsapp(false);
    }
  };

  return (
    <>
      <div className={styles.card}>
        <h3>Dados básicos</h3>
        <p className={styles.descricao}>Nome, endereço, telefone e email do estabelecimento.</p>
        <form className={styles.form} onSubmit={salvarDados}>
          <div className={styles.linhaCampos}>
            <div className={styles.formGroup}>
              <label>Nome</label>
              <input type="text" value={nomeEstabelecimento} onChange={(e) => setNomeEstabelecimento(e.target.value)} />
            </div>
            <div className={styles.formGroup}>
              <label>Telefone</label>
              <input type="text" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
            </div>
          </div>
          <div className={styles.formGroup}>
            <label>Endereço</label>
            <input type="text" value={endereco} onChange={(e) => setEndereco(e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Email</label>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <button className={styles.btnSalvar} type="submit" disabled={salvandoDados}>
            {salvandoDados ? 'Salvando...' : 'Salvar dados'}
          </button>
        </form>
      </div>

      <div className={styles.card}>
        <h3>Status da loja</h3>
        <p className={styles.descricao}>Controla se a loja aparece como aberta ou fechada para pedidos.</p>
        <div className={styles.statusRow}>
          <label className={styles.toggle}>
            <input
              type="checkbox"
              checked={estabelecimento.status_aberto === 'aberto'}
              onChange={alternarStatus}
              disabled={alterandoStatus}
            />
            <span className={styles.toggleSlider} />
          </label>
          <span>{estabelecimento.status_aberto === 'aberto' ? 'Aberta' : 'Fechada'}</span>
        </div>

        <form className={styles.form} onSubmit={salvarHorario}>
          <div className={styles.linhaCampos}>
            <div className={styles.formGroup}>
              <label>Abre às</label>
              <input type="time" value={horaAbertura} onChange={(e) => setHoraAbertura(e.target.value)} />
            </div>
            <div className={styles.formGroup}>
              <label>Fecha às</label>
              <input type="time" value={horaFechamento} onChange={(e) => setHoraFechamento(e.target.value)} />
            </div>
          </div>
          <button className={styles.btnSalvar} type="submit" disabled={salvandoHorario}>
            {salvandoHorario ? 'Salvando...' : 'Salvar horário'}
          </button>
        </form>
      </div>

      <div className={styles.card}>
        <h3>PIN da Tela da Cozinha</h3>
        <p className={styles.descricao}>Usado pelo tablet/TV da cozinha para autenticar sem login.</p>
        <div className={styles.statusRow}>
          <span className={styles.pinDisplay}>{pinCozinha || '------'}</span>
          <button className={styles.btnAcaoSecundaria} onClick={regenerarPin} disabled={regenerandoPin}>
            <MdRefresh /> {regenerandoPin ? 'Gerando...' : 'Gerar novo PIN'}
          </button>
        </div>
      </div>

      <div className={styles.card}>
        <h3>WhatsApp</h3>
        <p className={styles.descricao}>
          {estabelecimento.whatsapp_phone_number_id
            ? `Conectado${estabelecimento.whatsapp_display_phone_number ? ` — ${estabelecimento.whatsapp_display_phone_number}` : ''}. Para trocar o número, preencha os campos abaixo novamente.`
            : 'Cole o Phone Number ID e o Access Token gerados no Meta for Developers (WhatsApp Cloud API) para esta loja.'}
        </p>
        <form className={styles.form} onSubmit={conectarWhatsapp}>
          <div className={styles.formGroup}>
            <label>Phone Number ID</label>
            <input type="text" placeholder="Ex: 123456789012345" value={whatsappPhoneId} onChange={(e) => setWhatsappPhoneId(e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Access Token</label>
            <input type="password" placeholder="Cole o access token aqui" value={whatsappToken} onChange={(e) => setWhatsappToken(e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Número de exibição (opcional)</label>
            <input type="text" placeholder="Ex: +55 11 91234-5678" value={whatsappDisplay} onChange={(e) => setWhatsappDisplay(e.target.value)} />
          </div>
          <button className={styles.btnSalvar} type="submit" disabled={salvandoWhatsapp}>
            {salvandoWhatsapp ? 'Salvando...' : 'Conectar WhatsApp'}
          </button>
        </form>
      </div>
    </>
  );
}

// ===================== Aba: Mesas ===================== //
function AbaMesas({ idEstabelecimento }) {
  const [mesas, setMesas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [numeroMesa, setNumeroMesa] = useState('');
  const [capacidade, setCapacidade] = useState('');
  const [criando, setCriando] = useState(false);

  const carregarMesas = async () => {
    setLoading(true);
    try {
      // listarMesas devolve TODAS as mesas quando quem chama é master —
      // filtra pra esta loja no cliente.
      const res = await fetchWithAuth(`${API_URL}/mesas`);
      const data = await res?.json();
      const todas = Array.isArray(data) ? data : [];
      setMesas(todas.filter((m) => String(m.id_estabelecimento) === String(idEstabelecimento)));
    } catch (err) {
      console.error('Erro ao carregar mesas:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarMesas();
  }, [idEstabelecimento]);

  const criarMesa = async (e) => {
    e.preventDefault();
    if (!numeroMesa) {
      alert('Informe o número da mesa.');
      return;
    }
    setCriando(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/mesas`, {
        method: 'POST',
        body: JSON.stringify({
          numero_da_mesa: numeroMesa,
          capacidade: capacidade ? Number(capacidade) : null,
          id_estabelecimento: idEstabelecimento
        })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao cadastrar mesa.');
      setNumeroMesa('');
      setCapacidade('');
      carregarMesas();
    } catch (err) {
      alert(err.message);
    } finally {
      setCriando(false);
    }
  };

  const alternarAtiva = async (mesa) => {
    try {
      const res = await fetchWithAuth(`${API_URL}/mesas/${mesa.id_mesa}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ ativa: !mesa.ativa })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao alterar mesa.');
      carregarMesas();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <>
      <div className={styles.card}>
        <h3>Nova mesa</h3>
        <form className={styles.form} onSubmit={criarMesa}>
          <div className={styles.linhaCampos}>
            <div className={styles.formGroup}>
              <label>Número da mesa</label>
              <input type="text" value={numeroMesa} onChange={(e) => setNumeroMesa(e.target.value)} />
            </div>
            <div className={styles.formGroup}>
              <label>Capacidade (opcional)</label>
              <input type="number" min="1" value={capacidade} onChange={(e) => setCapacidade(e.target.value)} />
            </div>
          </div>
          <button className={styles.btnSalvar} type="submit" disabled={criando}>
            {criando ? 'Cadastrando...' : 'Cadastrar mesa'}
          </button>
        </form>
      </div>

      <div className={styles.tableContainer}>
        {loading ? (
          <p className={styles.loading}>Carregando mesas...</p>
        ) : mesas.length === 0 ? (
          <p className={styles.noData}>Nenhuma mesa cadastrada.</p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Número</th>
                <th>Capacidade</th>
                <th>Conta aberta</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {mesas.map((mesa) => (
                <tr key={mesa.id_mesa}>
                  <td>{mesa.numero_da_mesa}</td>
                  <td>{mesa.capacidade || '—'}</td>
                  <td>{mesa.conta_aberta ? 'Sim' : 'Não'}</td>
                  <td>{mesa.ativa ? <span className={styles.badgeAtivo}>Ativa</span> : <span className={styles.badgeInativo}>Inativa</span>}</td>
                  <td>
                    <button className={styles.btnAcaoSecundaria} onClick={() => alternarAtiva(mesa)}>
                      {mesa.ativa ? 'Desativar' : 'Reativar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

// ===================== Aba: Taxas de Entrega ===================== //
function AbaTaxasEntrega({ idEstabelecimento }) {
  const [taxas, setTaxas] = useState([]);
  const [taxaPadrao, setTaxaPadrao] = useState('');
  const [loading, setLoading] = useState(true);
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [valor, setValor] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [salvandoPadrao, setSalvandoPadrao] = useState(false);

  const carregar = async () => {
    setLoading(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/whatsapp/taxas-entrega?id_estabelecimento=${idEstabelecimento}`);
      const data = await res?.json();
      setTaxas(Array.isArray(data?.taxas) ? data.taxas : []);
      setTaxaPadrao(data?.taxa_padrao ?? '');
    } catch (err) {
      console.error('Erro ao carregar taxas de entrega:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar();
  }, [idEstabelecimento]);

  const criarTaxa = async (e) => {
    e.preventDefault();
    if (!bairro.trim() || valor === '') {
      alert('Informe o bairro e o valor.');
      return;
    }
    setSalvando(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/whatsapp/taxas-entrega`, {
        method: 'POST',
        body: JSON.stringify({ id_estabelecimento: idEstabelecimento, bairro, cidade, valor })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao cadastrar taxa.');
      setBairro('');
      setCidade('');
      setValor('');
      carregar();
    } catch (err) {
      alert(err.message);
    } finally {
      setSalvando(false);
    }
  };

  const removerTaxa = async (taxa) => {
    if (!window.confirm(`Remover a taxa do bairro "${taxa.bairro}"?`)) return;
    try {
      const res = await fetchWithAuth(`${API_URL}/whatsapp/taxas-entrega/${taxa.id}?id_estabelecimento=${idEstabelecimento}`, {
        method: 'DELETE'
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao remover taxa.');
      carregar();
    } catch (err) {
      alert(err.message);
    }
  };

  const salvarPadrao = async (e) => {
    e.preventDefault();
    setSalvandoPadrao(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/whatsapp/taxas-entrega/padrao`, {
        method: 'PUT',
        body: JSON.stringify({ id_estabelecimento: idEstabelecimento, valor: taxaPadrao === '' ? null : taxaPadrao })
      });
      const data = await res?.json();
      if (!res?.ok) throw new Error(data?.error || 'Erro ao salvar taxa padrão.');
      alert('Taxa padrão salva!');
    } catch (err) {
      alert(err.message);
    } finally {
      setSalvandoPadrao(false);
    }
  };

  return (
    <>
      <div className={styles.card}>
        <h3>Taxa padrão</h3>
        <p className={styles.descricao}>Usada quando o bairro digitado pelo cliente não está na lista abaixo. Deixe em branco para chamar um atendente nesse caso.</p>
        <form className={styles.form} onSubmit={salvarPadrao}>
          <div className={styles.formGroup} style={{ maxWidth: 200 }}>
            <label>Valor (R$)</label>
            <input type="number" min="0" step="0.01" value={taxaPadrao} onChange={(e) => setTaxaPadrao(e.target.value)} />
          </div>
          <button className={styles.btnSalvar} type="submit" disabled={salvandoPadrao}>
            {salvandoPadrao ? 'Salvando...' : 'Salvar taxa padrão'}
          </button>
        </form>
      </div>

      <div className={styles.card}>
        <h3>Nova taxa por bairro</h3>
        <form className={styles.form} onSubmit={criarTaxa}>
          <div className={styles.linhaCampos}>
            <div className={styles.formGroup}>
              <label>Bairro</label>
              <input type="text" value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className={styles.formGroup}>
              <label>Cidade (opcional)</label>
              <input type="text" value={cidade} onChange={(e) => setCidade(e.target.value)} />
            </div>
            <div className={styles.formGroup}>
              <label>Valor (R$)</label>
              <input type="number" min="0" step="0.01" value={valor} onChange={(e) => setValor(e.target.value)} />
            </div>
          </div>
          <button className={styles.btnSalvar} type="submit" disabled={salvando}>
            {salvando ? 'Salvando...' : 'Adicionar taxa'}
          </button>
        </form>
      </div>

      <div className={styles.tableContainer}>
        {loading ? (
          <p className={styles.loading}>Carregando taxas...</p>
        ) : taxas.length === 0 ? (
          <p className={styles.noData}>Nenhuma taxa de bairro cadastrada.</p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Bairro</th>
                <th>Cidade</th>
                <th>Valor</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {taxas.map((taxa) => (
                <tr key={taxa.id}>
                  <td>{taxa.bairro}</td>
                  <td>{taxa.cidade || '—'}</td>
                  <td>R$ {Number(taxa.valor).toFixed(2)}</td>
                  <td>
                    <button className={styles.btnIconePerigo} onClick={() => removerTaxa(taxa)} title="Remover">
                      Remover
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default GerenciarEstabelecimento;
